import React, { useRef } from 'react';
import { EmployeesList } from "./sections/EmployeesList";
import { User } from '@/types';

interface Department {
  id: string;
  name: string;
  company_id: string;
}

interface EmployeesSectionProps {
  onViewProfile: (employee: User) => void;
  onEdit: (employee: User) => void;
  onViewOvertimeHistory: (employee: User) => void;
  onChangeDepartmentProp: (employeeId: string, newDepartment: string) => void;
  onChangeStatus: (employee: User) => void;
  canCreateUsers: boolean;
  isNewUserDialogOpen: boolean;
  setIsNewUserDialogOpen: (open: boolean) => void;
  addEmployee: (employeeData: Partial<Omit<User, 'id'>> & { email: string; name: string; role: string }, shiftAssignment?: { shiftId: string; fromDate: string; toDate?: string }) => Promise<void>;
  departments?: Department[];
  isLoadingDepartments?: boolean;
  acceptedDomains?: string[];
  // ✅ NEW: Add centralized state props
  employees: User[];
  isLoadingEmployees: boolean;
  employeesError: string | null;
}

export function EmployeesSection({
  onViewProfile,
  onEdit,
  onViewOvertimeHistory,
  onChangeDepartmentProp,
  onChangeStatus,
  canCreateUsers,
  isNewUserDialogOpen,
  setIsNewUserDialogOpen,
  addEmployee,
  // departments,
  isLoadingDepartments,
  // acceptedDomains,
  // ✅ NEW: Use centralized state props
  employees,
  isLoadingEmployees,
  employeesError
}: EmployeesSectionProps) {
  
  // ✅ NEW: Use centralized state instead of context
  const isLoading = isLoadingEmployees || isLoadingDepartments;

  // Create a dummy ref in case it's still needed by some components
  const dummyRef = useRef<HTMLDivElement>(null);

  // ✅ NEW: Show error if employee loading fails
  if (employeesError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <h3 className="text-red-800 font-semibold">Error Loading Employees</h3>
        <p className="text-red-600 mt-2">{employeesError}</p>
      </div>
    );
  }

  return (
    <>
      <EmployeesList
        users={employees}
        isLoading={isLoading}
        canCreateUsers={canCreateUsers}
        isNewUserDialogOpen={isNewUserDialogOpen}
        setIsNewUserDialogOpen={setIsNewUserDialogOpen}
        addEmployee={addEmployee}
        onViewProfile={onViewProfile}
        onEdit={onEdit}
        onViewOvertimeHistory={onViewOvertimeHistory}
        handleDepartmentChange={onChangeDepartmentProp}
        onChangeStatus={onChangeStatus}
      />
      
      {/* Hidden div for backward compatibility with any code that might be using it */}
      <div ref={dummyRef} style={{ display: 'none' }} />
    </>
  );
}
